import utils from 'lg-vue-components/store/modules/layout/utils';
import getters from 'lg-vue-components/store/modules/layout/getters';

const mutations = {
  setDadosLayout(state, {
    nomePortal, logotipo, usuario, menus, produtos, tempoDeSessao,
  }) {
    state.nomePortal = nomePortal || '';
    state.logotipo = logotipo || '';

    state.menus.splice(0);
    utils.mapeiaUID(state.menus, menus);

    state.menuMapeado = [...utils.mapeieObjetoMenu(state.menus)];

    mutations.setDadosUsuarioLogado(state, usuario);

    utils.tenteRecuperarParametrosDaQuery(state);

    if (!state.menuAtivo && state.menuMapeado.length > 0) {
      mutations.setPrimeiraFuncaoAtiva(state);
    } else {
      mutations.setMenuAtivo(state, {
        codigo: state.menuAtivo,
        uid: state.menuUid,
      });
    }

    state.produtos.splice(0);
    state.produtos = [...(produtos || [])];

    state.tempoDeSessao = tempoDeSessao;

    if (menus || nomePortal) {
      state.carregandoLayout = false;
    }

    if (logotipo) {
      state.carregandoLogotipo = false;
    }

    if (usuario) {
      state.carregandoUsuario = false;
    }
  },
  setDadosUsuarioLogado(state, usuario) {
    state.usuario = { ...(usuario || {}) };

    const menusUsuario = [];

    utils.mapeiaUID(menusUsuario, state.usuario.menus);
    utils.mapeieMenuSeNaoExiste(state, menusUsuario);

    state.usuario.menus = [...menusUsuario];
    state.usuario.configuracao = state.usuario.configuracao || {};
    state.carregandoUsuario = !usuario;
  },
  setDadosProdutos(state, produtos) {
    state.produtos.splice(0);
    state.produtos = [...produtos];
  },
  setAcaoCustomizada(state, objAcao) {
    if (objAcao && objAcao.id && objAcao.callback) {
      state.acoesCustomizadas[objAcao.id] = objAcao.callback;
    }
  },
  setNovasRotasMenu(state, rotas) {
    if (rotas && Array.isArray(rotas)) {
      rotas.forEach((menu) => {
        const obj = menu;

        obj.uid = utils.getUID(menu);

        if (!getters.getMenuPorUID(state)(obj.uid)) {
          state.menuMapeado.push(menu);
        }
      });
    }
  },
  setLogotipo(state, urlLogo) {
    state.logotipo = urlLogo;
    state.carregandoLogotipo = false;
  },
  setSidebarAtiva(state, forcarFechamento) {
    state.statusSidebar = forcarFechamento ? false : !state.statusSidebar;
  },
  setMenuAtivo(state, { codigo, uid, descricao }) {
    let menuFinal = null;
    const menusEncontrados = getters.getMenusPorCodigo(state)(codigo);

    if (menusEncontrados.length > 1) {
      menuFinal = getters.getMenuPorUID(state)(uid);
    }

    if (!menuFinal && menusEncontrados.length === 1) {
      [menuFinal] = menusEncontrados;
    } else if ((!menuFinal || !menuFinal.ehMenuPrincipal) && menusEncontrados.length > 1) {
      for (let i = 0; i < menusEncontrados.length; i += 1) {
        const element = menusEncontrados[i];

        if (element.ehMenuPrincipal) {
          menuFinal = element;
          break;
        }
      }
    }

    if (menuFinal) {
      utils.atualizeControleMenu(state, {
        ...menuFinal,
        descricao: descricao || menuFinal.descricao,
      });
      mutations.setMenusAbertosComBaseItemSelecionado(state);
    } else {
      utils.atualizeControleMenu(state, {
        codigo: '',
        uid: '',
      });
    }
  },
  setPrimeiraFuncaoAtiva(state) {
    mutations.setMenuAtivo(state, state.menuMapeado[0].codigo);
  },
  setMenusAbertosComBaseItemSelecionado(state) {
    let menusAbertos = [];

    if (state.menuUid) {
      menusAbertos = [...utils.buscarPaisPorUID(state.menus, state.menuUid)];
    }

    if (!menusAbertos.length) {
      menusAbertos = [...utils.buscarPaisDoMenu(state.menus, state.menuAtivo)];
    }

    state.menusAbertos.splice(0);
    state.menusAbertos = [...menusAbertos];
  },
  setCarregandoUsuario(state, carregando) {
    state.carregandoUsuario = carregando;
  },
  setMenusAbertos(state, { codigo, nivel }) {
    const abrirMenu = getters.getMenusAbertos(state)(codigo) === undefined;

    if (abrirMenu) {
      if (nivel === 0) {
        state.menusAbertos.splice(0);
      }

      state.menusAbertos.push(codigo);
    } else {
      const index = state.menusAbertos.indexOf(codigo);

      state.menusAbertos.splice(index, 1);
    }
  },
  setSidebarPesquisaAtiva(state, forcarFechamento) {
    state.statusSidebarPesquisa = forcarFechamento ? false : !state.statusSidebarPesquisa;
  },
};

export default mutations;
